var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProposal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.109,
    height: 71.386,
    viewBox: "0 0 57.109 71.386",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_description_24px",
    d: "M39.693,2H11.139a7.129,7.129,0,0,0-7.1,7.139L4,66.248a7.129,7.129,0,0,0,7.1,7.139H53.97a7.16,7.16,0,0,0,7.139-7.139V23.416Zm7.139,57.109H18.277V51.97H46.832Zm0-14.277H18.277V37.693H46.832ZM36.124,26.985V7.354L55.755,26.985Z",
    transform: "translate(-4 -2)",
    fill: "#e3e3e3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProposal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Proposal.f495c0fe03bc346fbf7c84a0ae7fcd1e.svg";